import { Directive, Input, ElementRef, Inject, OnInit } from '@angular/core';
@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[focus]'
})
export class FocusDirective implements OnInit {

    @Input()
    focus: boolean;
    constructor( @Inject(ElementRef) private element: ElementRef) {






    }
    ngOnInit(): void {
        this.element.nativeElement.focus();
    }
}



// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/app.focus.directive.ts